<template>
    <v-btn 
        :key="petId" 
        class="cardbutton"
        @click="$router.push({name: 'pet', params:{petId:petId}});"

    > 
        <strong>{{pet.name}}</strong>&nbsp;<span style="color:gray;">#{{petId}}</span><br>
        {{pet.species}} {{pet.breed}}<br>
        <span v-if="pet.microchip">Microchip: {{pet.microchip}}</span>
    </v-btn>
</template>

<script>
const axios = require('axios').default;
export default {
  name: "Pet",
  props: ["petId"],
  data() {
    return {
        pet:{
            species: null,
            breed: null,
            name: null,
            microchip: null
        }
    };
  },
  methods: {
        reload() {
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "getPet.php?petId="+vm.petId,
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.pet = response.data.resource;
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            });
        }
  },
  mounted() {
    let vm = this;
    vm.reload();
  },
  watch: {
    petId: {
      handler: function () {
        let vm = this;
        vm.reload();
      },
      immediate: true,
    }
  },
};
</script>

<style>
    .cardbutton .v-btn__content{
        display:block!important;
        text-align: left;
    }
    .cardbutton{
        padding: 30px 20px;
    }
</style>
